import { Button, Flex, FormControl, Text } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { FormModal } from "../../components/Forms/FormModal";
import { Input } from "../../components/Forms/Input";
import { PadlockIcon } from "../../styles/icons/Padlock";
import { Section } from "./_Section";
import * as yup from "yup";
import { PadlockIconClosed } from "../../styles/icons/PadlockClosed";
import { SellerBlockData } from "../../models/Sellers";
import { useSeller } from "../../hooks/useSeller";
import { useUserInfo } from "../../utils/getUserInfo";
import { showToast } from "../../utils";
import { Modal2FA } from "./Modal2FA";
import { Alert } from "../../components/Alert";

const SELLER_FRONT_URL = process.env.REACT_APP_SELLER_FRONT_URL || "https://app.barte.com";

interface LoginSectionProps {
  id: string;
}
const disableSellerSchema = yup.object().shape({
  password: yup.string().required("Preenchimento obrigatório!"),
});

export function LoginSection({ id }: LoginSectionProps) {
  const user = JSON.parse(localStorage.getItem("barte-user-info"));
  const { roles } = useUserInfo();
  const isBackofficeEmail = (email: string) => /^backoffice-[a-f0-9][a-f0-9-]{8,}[a-f0-9]@barte\.com$/.test(email);
  const canImpersonate = roles.includes("SELLER_IMPERSONATE");
  const [blockAlertState, setBlockAlertState] = useState(false);
  const [blockBankingAlertState, setBlockBankingAlertState] = useState(false);
  const [confirmBlockBankingAlertState, setConfirmBlockBankingAlertState] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingBanking, setIsSubmittingBanking] = useState(false);
  const { seller, getSellerData } = useSeller();
  const cancelRef = useRef(null);
  const [impersonatingEmail, setImpersonatingEmail] = useState<string | null>(null);
  const { register, handleSubmit } = useForm({
    resolver: yupResolver(disableSellerSchema),
  });
  const { register: registerBanking, handleSubmit: handleSubmitBanking } = useForm({
    resolver: yupResolver(disableSellerSchema),
  });
  const { patchBlockUser, patchBlockBanking, impersonateSeller } = useSeller();

  const handleImpersonate = async (userEmail: string) => {
    try {
      setImpersonatingEmail(userEmail);
      const response = await impersonateSeller(id, userEmail);
      const sellerFrontUrl = `${SELLER_FRONT_URL}/auth/impersonate?token=${response.accessToken}`;
      window.open(sellerFrontUrl, "_blank");
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message || "Erro ao impersonar seller";
      showToast({ type: "error", message: errorMsg });
    } finally {
      setImpersonatingEmail(null);
    }
  };

  const onSubmit = handleSubmit(async ({ password }: SellerBlockData) => {
    try {
      setIsSubmitting(true);
      const blockSellerData = {
        password,
        active: !seller?.isBlocked
      }
      await patchBlockUser(id, blockSellerData);
      await getSellerData(id);
      showToast({ message: `Seller ${seller?.isBlocked ? "desbloqueado" : "bloqueado"} com sucesso`, type: "success" });
      setBlockAlertState(false);
      window.location.reload();
    } catch (error: any) {
      console.error('=== ERRO COMPLETO ===');
      console.error('Error object:', error);
      console.error('Response data:', error?.response?.data);
      console.error('Response status:', error?.response?.status);
      console.error('Response headers:', error?.response?.headers);

      // Log detalhado dos erros
      if (error?.response?.data) {
        console.error('=== DETALHES DO ERRO ===');
        console.error('Errors array:', JSON.stringify(error?.response?.data?.errors, null, 2));
        console.error('Metadata:', JSON.stringify(error?.response?.data?.metadata, null, 2));
        console.error('Objeto completo:', JSON.stringify(error?.response?.data, null, 2));
      }

      // Mostra a mensagem de erro da API se disponível
      if (error?.response?.data?.errors) {
        error?.response?.data?.errors?.map((error: any) => (
          showToast({
            type: "error",
            message: `${error?.code} - ${error?.description}`
          })
        ));
      } else if (error?.response?.data?.message) {
        showToast({
          type: "error",
          message: error?.response?.data?.message
        });
      } else {
        showToast({
          type: "error",
          message: `Erro ao bloquear/desbloquear acesso Banking: ${error?.message}`
        });
      }
      return
    } finally {
      setIsSubmitting(false);
    }
  });

  const onSubmitBanking = handleSubmitBanking(async ({ password }: SellerBlockData) => {
    try {
      setIsSubmittingBanking(true);

      console.log('=== DEBUG BLOCK BANKING ===');
      console.log('Seller ID:', id);
      console.log('Seller isBlocked:', seller?.isBlocked);

      const blockSellerData = {
        pass: password,  // A API Banking espera 'pass', não 'password'
        blocked: !seller?.isBlocked  // blocked: true para bloquear, false para desbloquear
      }
      console.log('Dados enviados:', blockSellerData);

      await patchBlockBanking(id, blockSellerData);
      await getSellerData(id);
      showToast({ message: `Acesso Banking ${seller?.isBlocked ? "desbloqueado" : "bloqueado"} com sucesso`, type: "success" });
      setBlockBankingAlertState(false);
      window.location.reload();
    } catch (error: any) {
      console.error('=== ERRO COMPLETO ===');
      console.error('Error object:', error);
      console.error('Response data:', error?.response?.data);
      console.error('Response status:', error?.response?.status);
      console.error('Response headers:', error?.response?.headers);

      // Log detalhado dos erros
      if (error?.response?.data) {
        console.error('=== DETALHES DO ERRO ===');
        console.error('Errors array:', JSON.stringify(error?.response?.data?.errors, null, 2));
        console.error('Metadata:', JSON.stringify(error?.response?.data?.metadata, null, 2));
        console.error('Objeto completo:', JSON.stringify(error?.response?.data, null, 2));
      }

      // Mostra a mensagem de erro da API se disponível
      if (error?.response?.data?.errors) {
        error?.response?.data?.errors?.map((error: any) => (
          showToast({
            type: "error",
            message: `${error?.code} - ${error?.description}`
          })
        ));
      } else if (error?.response?.data?.message) {
        showToast({
          type: "error",
          message: error?.response?.data?.message
        });
      } else {
        showToast({
          type: "error",
          message: `Erro ao bloquear/desbloquear acesso Banking: ${error?.message}`
        });
      }
      return
    } finally {
      setIsSubmittingBanking(false);
    }
  });

  useEffect(() => {
    getSellerData(id);
    // eslint-disable-next-line
  }, [id]);

  return (
    <>
      <FormModal
        title="Bloquear acesso desse seller à plataforma?"
        isOpen={blockAlertState}
        onClose={() => setBlockAlertState(!blockAlertState)}
        handleConfirmModal={onSubmit}
        isSubmitting={isSubmitting}
        width="420px"
        confirmationButtonText={seller?.isBlocked ? "Desbloquear acesso" : "Bloquear acesso"}
        isAllowToSubmit
      >
        <Flex
          gap="4"
          direction="column"
        >
          {seller?.isBlocked
            ? <Text>Esse cliente voltara a ter o acesso à plataforma.</Text>
            : <Text>Esse cliente não poderá mais ter acesso à plataforma, realizar cobranças ou receber pagamentos até que seja desbloqueado.</Text>
          }
          <Input
            label="Código de bloqueio"
            name="password"
            p="4"
            register={{ ...register("password") }}
          />
        </Flex>
      </FormModal>
      <FormModal
        title="Bloquear acesso Banking desse seller?"
        isOpen={blockBankingAlertState}
        onClose={() => setBlockBankingAlertState(!blockBankingAlertState)}
        handleConfirmModal={onSubmitBanking}
        isSubmitting={isSubmittingBanking}
        width="420px"
        confirmationButtonText={seller?.isBlocked ? "Desbloquear acesso Banking" : "Bloquear acesso Banking"}
        isAllowToSubmit
      >
        <Flex
          gap="4"
          direction="column"
        >
          {seller?.isBlocked
            ? <Text>Esse cliente voltará a ter o acesso ao Banking.</Text>
            : <Text>Esse cliente não poderá mais ter acesso ao Banking até que seja desbloqueado.</Text>
          }
          <Input
            label="Código de bloqueio"
            name="password"
            p="4"
            register={{ ...registerBanking("password") }}
          />
        </Flex>
      </FormModal>
      <Alert
        isOpen={confirmBlockBankingAlertState}
        onClose={() => setConfirmBlockBankingAlertState(false)}
        title="Tem certeza que deseja bloquear o acesso Banking?"
        messageBody="Esta ação bloqueará o acesso do seller ao Banking. Você precisará confirmar com sua senha."
        confirmButtonText="Continuar"
        closeButtonText="Cancelar"
        onConfirm={() => {
          setConfirmBlockBankingAlertState(false);
          setBlockBankingAlertState(true);
        }}
        leastDestructiveRef={cancelRef}
      />
      <Section
        sectionTitle="Acesso"
        onClickEditButton={() => { }}
        onClickConfirmButton={() => { }}
        buttons={[
          user?.email?.includes("@barte") && (
            <Button
              borderRadius="2px"
              border="1px solid #D9D9D9"
              bgColor="white"
              p="0 0.5rem"
              fontSize="14px"
              onClick={() => setBlockAlertState(!blockAlertState)}
            >
              <Flex
                align="center"
                gap="2"
              >
                {seller?.isBlocked ? <PadlockIcon size={14} /> : <PadlockIconClosed size={14} />}
                {seller?.isBlocked ? <Text>Desbloquear acesso</Text> : <Text>Bloquear acesso</Text>}
              </Flex>

            </Button>
          ),
          user?.email?.includes("@barte") && (
            <Button
              borderRadius="2px"
              border="1px solid #D9D9D9"
              bgColor="white"
              p="0 0.5rem"
              fontSize="14px"
              onClick={() => setConfirmBlockBankingAlertState(true)}
            >
              <Flex
                align="center"
                gap="2"
              >
                {seller?.isBlocked ? <PadlockIcon size={14} /> : <PadlockIconClosed size={14} />}
                <Text>Bloquear acesso Banking</Text>
              </Flex>

            </Button>
          )
        ]}
      >
        {(seller?.users?.length < 0) ?

          <Text>{"Nenhuma informação de login"}</Text> :
          seller?.users?.map(seller => (
            <Flex gap={4} key={seller.user} alignItems="flex-end">
              <FormControl maxWidth="280px">
                <Input
                  p="0"
                  label="Usuário"
                  name="login_user"
                  defaultValue={seller.user}
                  _disabled={{
                    bg: "transparent",
                    border: "none",
                  }}
                  isDisabled
                />
              </FormControl>
              {!isBackofficeEmail(seller?.user) && canImpersonate && (
                <Button
                  size="sm"
                  variant="primary"
                  isLoading={impersonatingEmail === seller.user}
                  onClick={() => handleImpersonate(seller.user)}
                >
                  Impersonar
                </Button>
              )}
              <FormControl maxWidth="280px">
                <Input
                  p="0"
                  label="Permissão"
                  name="login_permission"
                  defaultValue={seller.permission}
                  _disabled={{
                    bg: "transparent",
                    border: "none",
                  }}
                  isDisabled
                />
              </FormControl>
              {!isBackofficeEmail(seller?.user) &&
                <Flex flexDirection="column" gap="7px">
                  <Text
                    fontSize="12px"
                    fontWeight="400"
                    lineHeight="16px"
                    fontFamily="Hero New"
                    color="rgba(138, 148, 168, 1)"
                  >
                    Autenticação 2FA
                  </Text>
                  <Modal2FA />
                </Flex>
              }
            </Flex>
          ))
        }
      </Section>
    </>


  );
}